import { TimeContext } from 'contexts/TimeFormContext';
import { ITime } from 'models/timeForm/timeForm.model';
import { useState } from 'react';

function TimeFormProvider(props) {
	const [editTimeForm, setEditTimeForm] = useState<ITime | undefined>(
		undefined
	);
	const [resetBreakForm, setResetBreakForm] = useState<boolean>(false);

	const states = { editTimeForm, resetBreakForm };
	const setters = { setEditTimeForm, setResetBreakForm };

	return (
		<TimeContext.Provider value={{ states, setters }}>
			{props.children}
		</TimeContext.Provider>
	);
}

export default TimeFormProvider;
